import React from "react";
import { Box, Typography, Button, Alert } from "@mui/material";
import SecurityIcon from "@mui/icons-material/Security";

interface TwoFactorPromptProps {
  onEnable2FA: () => void;
  onSkip: () => void;
  isLoading?: boolean;
}

const TwoFactorPrompt: React.FC<TwoFactorPromptProps> = ({ onEnable2FA, onSkip, isLoading = false }) => {
  return (
    <Box sx={{ pb: 4 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
        <SecurityIcon sx={{ mr: 2, fontSize: "2rem", color: "error.main" }} />
        <Typography variant="subtitle1">Setup Required</Typography>
      </Box>

      <Alert severity="error" sx={{ mb: 4 }}>
        <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
          Two-Factor Authentication is required
        </Typography>
        <Typography variant="body2">
          For enhanced security, all accounts must have two-factor authentication enabled. Please set up 2FA to continue accessing your
          account.
        </Typography>
      </Alert>

      <Box sx={{ display: "flex", gap: 2, flexDirection: { xs: "column", sm: "row" } }}>
        <Button
          variant="contained"
          onClick={onEnable2FA}
          disabled={isLoading}
          sx={{
            flex: 1,
            textTransform: "none",
            py: 1.5,
          }}
          startIcon={<SecurityIcon />}
        >
          Enable Two-Factor Authentication
        </Button>

        <Button
          variant="outlined"
          onClick={onSkip}
          disabled={isLoading}
          color="error"
          sx={{
            textTransform: "none",
            py: 1.5,
            minWidth: { sm: "120px" },
          }}
        >
          Logout
        </Button>
      </Box>

      <Typography variant="caption" sx={{ mt: 2, display: "block", color: "text.secondary" }}>
        Two-factor authentication is mandatory for all accounts
      </Typography>
    </Box>
  );
};

export default TwoFactorPrompt;
